import AMIT from "../../../../assets/PARP/thief.png";
import Agresion from "../../../../assets/PARP/aggression.png";
import HAMCC from "../../../../assets/PARP/HAMCC.png";
import Terrorismo from "../../../../assets/PARP/threat.png";

// Mismo color por categoría en el formulario de creación y en la tabla de eventos.
export const CATEGORY_COLORS = {
  riesgo: "gold",
  contravención: "blue",
  delito: "red",
};

export const categories = [
  {
    key: "riesgo",
    label: "Riesgos de Proceso",
    subItems: [
      {
        key: "amit",
        label: "AMIT",
        options: [
          {
            label: "Vandalismo y Daño a la infraestructura",
            value: "afectacion-a-la-infraestructura",
            protocol: "amit",
          },
          {
            label: "Vandalismo y Daño a Material Rodante",
            value: "afectacion-al-material-rodante",
            protocol: "amit",
          },
          {
            label: "Ocupación de predios privados de uso público Metro",
            value: "ocupacion-predios-privados",
            protocol: "amit",
          },
          {
            label: "Intrusión",
            value: "ingreso-de-personas-y/o-vehiculos",
            protocol: "amit",
          },
          {
            label: "Acceso no autorizado",
            value: "acceso_no_autorizado",
            protocol: "amit",
          },
        ],
        image: AMIT,
      },
      {
        key: "hamcc",

        label: "Hamcc",
        options: [
          { label: "Huelga", value: "huelga", protocol: "hamcc" },
          { label: "Asonada", value: "asonada", protocol: "hamcc" },
          { label: "Motín", value: "motin", protocol: "hamcc" },
          {
            label: "Conmoción ciudadana",
            value: "conmocion-ciudadana",
            protocol: "hamcc",
          },
        ],
        image: HAMCC,
      },
      {
        key: "hurto",
        label: "Hurto",
        options: [
          {
            label: "Hurto por destreza",
            value: "hurto-destreza",
            protocol: "delitos",
          },
          {
            label: "Hurto aprovechando descuido",
            value: "hurto-descuido",
            protocol: "delitos",
          },
          {
            label: "Hurto ejerciendo la fuerza",
            value: "hurto-fuerza",
            protocol: "delitos",
          },
        ],
        image: Agresion,
      },
      {
        key: "terrorismo",
        label: "Terrorismo",
        options: [
          {
            label: "Clave Beta Amarilla",
            value: "clave-beta-amarilla",
            protocol: "terrorismo",
          },
          {
            label: "Clave Beta Naranja",
            value: "clave-beta-naranja",
            protocol: "terrorismo",
          },
          {
            label: "Clave Beta Roja",
            value: "clave-beta-roja",
            protocol: "terrorismo",
          },
          {
            label: "Clave Beta Negra",
            value: "clave-beta-negra",
            protocol: "terrorismo",
          },
        ],
        image: Terrorismo,
      },
    ],
  },
  {
    key: "contravención",
    label: "Contravenciones",
    subItems: [
      {
        label: "Consumir bebidas alcohólicas o sustancias psicoactivas",
        value: "consumir-sustancias",
        protocol: "incumplimiento-al-reglamento-del-usuario",
      },
      {
        label: "Evasión de medios de pago",
        value: "evasion-medios-pago",
        protocol: "incumplimiento-al-reglamento-del-usuario",
      },
      {
        label: "Mendicidad, comercio informal o comunicaciones no autorizadas",
        value: "mendicidad-comercio-informal",
        protocol: "incumplimiento-al-reglamento-del-usuario",
      },
      {
        label: "Paquetes sobre dimensionados",
        value: "paquetes-sobredimensionados",
        protocol: "incumplimiento-al-reglamento-del-usuario",
      },
      {
        label: "Persona en sitio no autorizado o en retorno",
        value: "persona-no-autorizada",
        protocol: "incumplimiento-al-reglamento-del-usuario",
      },
    ],
  },
  {
    key: "delito",
    protocol: "delitos",
    label: "Delitos",
    subItems: [
      { label: "Acoso sexual", value: "acoso_sexual", protocol: "delitos" },
      { label: "Amenazas", value: "amenazas", protocol: "delitos" },
      {
        label: "Daño en bien ajeno (No bienes Metro)",
        value: "dano-bien-ajeno",
        protocol: "delitos",
      },
      { label: "Estafa", value: "estafa", protocol: "delitos" },
      { label: "Extorsión", value: "extorsion", protocol: "delitos" },
      { label: "Homicidio", value: "homicidio", protocol: "delitos" },
      {
        label: "Hurto (cosquilleo, atraco, descuido)",
        value: "hurto-tipos",
        protocol: "delitos",
      },
      {
        label: "Injurias y calumnias (agresión verbal)",
        value: "injurias-calumnias",
        protocol: "delitos",
      },
      {
        label:
          "Injuria por vías de hecho (Mirar, tocar, decir, seguir o grabar/fotografiar)",
        value: "injuria-vias-hecho",
        protocol: "delitos",
      },
      {
        label: "Lesiones personales (agresión física)",
        value: "lesiones-personales",
        protocol: "delitos",
      },
      { label: "Secuestro", value: "secuestro", protocol: "delitos" },
    ],
  },
  {
    key: "otros",
    label: "Otros",
    subItems: [
      {
        key: "persona-herida",
        label: "Persona herida",
        options: [
          {
            label: "NA (No Aplica)",
            value: "persona-herida-na",
            protocol: "persona-herida",
          },
        ],
      },
      {
        key: "persona-fallecida",
        label: "Persona Fallecida",
        options: [
          {
            label: "NA (No Aplica)",
            value: "persona-fallecida-na",
            protocol: "persona-fallecida",
          },
        ],
      },
      {
        key: "clave-alpha",
        label: "Clave alpha",
        options: [
          {
            label: "Fallecido",
            value: "clave-alpha-fallecido",
            protocol: "clave-alpha",
          },
          {
            label: "Herido",
            value: "clave-alpha-herido",
            protocol: "clave-alpha",
          },
          {
            label: "Sin lesiones",
            value: "clave-alpha-sin-lesiones",
            protocol: "clave-alpha",
          },
        ],
      },
      {
        key: "emergencias",
        label: "Emergencias",
        options: [
          {
            label: "Accidente aéreo",
            value: "emergencia-accidente-aereo",
            protocol: "emergencias",
          },
          {
            label: "Caída de cabinas",
            value: "emergencia-caida-cabinas",
            protocol: "emergencias",
          },
          {
            label: "Clave delta",
            value: "emergencia-clave-delta",
            protocol: "emergencias",
          },
          {
            label: "Clave kappa",
            value: "emergencia-clave-kappa",
            protocol: "emergencias",
          },
          {
            label: "Enjambres",
            value: "emergencia-enjambres",
            protocol: "emergencias",
          },
          {
            label: "Eventos atmosféricos",
            value: "emergencia-eventos-atmosfericos",
            protocol: "emergencias",
          },
          {
            label: "Explosión",
            value: "emergencia-explosion",
            protocol: "emergencias",
          },
          {
            label: "Incendio",
            value: "emergencia-incendio",
            protocol: "emergencias",
          },
          {
            label: "Inhalación de gases tóxicos",
            value: "emergencia-inhalacion-gases-toxicos",
            protocol: "emergencias",
          },
          {
            label: "Intoxicación masiva",
            value: "emergencia-intoxicacion-masiva",
            protocol: "emergencias",
          },
          {
            label: "Inundación",
            value: "emergencia-inundacion",
            protocol: "emergencias",
          },
          {
            label: "Materiales peligrosos",
            value: "emergencia-materiales-peligrosos",
            protocol: "emergencias",
          },
          {
            label: "Movimientos sísmicos",
            value: "emergencia-movimientos-sismicos",
            protocol: "emergencias",
          },
          {
            label: "Plagas",
            value: "emergencia-plagas",
            protocol: "emergencias",
          },
          {
            label: "Rescate en cables aéreos",
            value: "emergencia-rescate-cables-aereos",
            protocol: "emergencias",
          },
        ],
      },
    ],
  },
];
